import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FareProduct, PaymentMethod } from '../../services/types/apitypes';
import PaymentMethodSelector from '../payments/PaymentMethodSelector';
import PaymentTotal from '../payments/PaymentTotal';
import { IonButton } from '@ionic/react';

type CardPassesPayTopProps = {
  paymentMethod: PaymentMethod;
  product: FareProduct;
  chosePayments: () => void;
  finish: (pa: PaymentMethod, pr: FareProduct) => void;
  collectJs: any;
};

export default function CardPassesPayBottom({
  paymentMethod,
  chosePayments,
  finish,
  product,
  collectJs,
}: CardPassesPayTopProps) {
  const [t] = useTranslation('global');

  useLayoutEffect(() => {
    if (collectJs) {
      collectJs.configure();
    }
  }, [collectJs]);

  return (
    <>
      <PaymentMethodSelector payment={paymentMethod} click={chosePayments} />
      <PaymentTotal amount={product.price / 100} />
      <div className="pt-3 ion-text-center">
        <IonButton
          className="btn-default btn-wide-80"
          onClick={() => finish(paymentMethod, product)}
        >
          {t('cardpasses.paynow')}
        </IonButton>
      </div>
    </>
  );
}
